/* eslint-disable perfectionist/sort-objects */
export const Urls = {
  LoginPage: '/login',
  OutcomePage: '/outcome',
  IncomePage: '/income',
  Profile: '/profile',
  Operators: '/operators',
  Cards: '/cards',
  Tariffs: '/tariffs',
  Banks: '/banks',
  Devices: '/devices',
  Holders: '/holders',
  Corrections: '/corrections',
  Debtors: '/debtors',
  Transactions: '/transactions',
  Traders: '/traders',
  Statistic: '/statistics',
  CardStatement: '/statement',
  Settings: '/settings',
  BlackList: '/black-list',
  GreyList: '/grey-list'
};
